import { render } from "./Reward.vue?vue&type=template&id=1e0dd1a2"
import script from "./Reward.vue?vue&type=script&lang=js"
export * from "./Reward.vue?vue&type=script&lang=js"

import exportComponent from "/builds/skilltech-ph/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__